import * as Yup from 'yup';

// User sign up form validation
export const addUserValidationSchema = Yup.object({
    hierarchyLevel: Yup.string().required('Please select an option'),
    partner: Yup.string().when('hierarchyLevel', {
        is: (val: string) => {
            return val === 'NPI';
        },
        then: Yup.string().optional(),
        otherwise: Yup.string().required('Partner is required'),
    }),
    partnerOfPartner: Yup.string(),
    firstName: Yup.string().required('Please enter a first name'),
    lastName: Yup.string().required('Please enter a last name'),
    mobileNumber: Yup.string()
        .matches(/^[0-9]*$/, 'Mobile number must only contain numbers')
        .max(20, 'Mobile number must be at most 20 characters')
        .required('Mobile number is required'),
    emailAddress: Yup.string().email('Enter a valid email').required('Email is required'),
    userRole: Yup.string().required('Please select an option'),
});

export const editUserDetailsValidationSchema = Yup.object({
    firstName: Yup.string().required('Please enter a first name'),
    lastName: Yup.string().required('Please enter a last name'),
    phoneNumber: Yup.string()
        .matches(/^[0-9]*$/, 'Mobile number must only contain numbers')
        .max(20, 'Mobile number must be at most 20 characters')
        .required('Mobile number is required'),
    emailAddress: Yup.string().email('Enter a valid email').required('Email is required'),
    userRole: Yup.string().required('Please select an option'),
});

export const addUserRoleValidationSchema = Yup.object({
    name: Yup.string().required('Please enter a role name'),
    hierarchyLevel: Yup.string().required('Please select Hierarchy Level'),
});

export const editUserRoleValidationSchema = Yup.object({
    role: Yup.string().required('Please enter a role name'),
    hierarchyLevel: Yup.string().required('Please select an option'),
});

export const maskString = (value: string): string => {
    const maskedValue = value.slice(-4).padStart(value.length, '*');
    return maskedValue;
};

export const isEmailValid = (email: string): boolean => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
export const partnerResourceValidationSchema = Yup.object().shape({
    resource_name: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
    viewAccessPermissions: Yup.string().required('Required'),
    resource_type: Yup.string().required('Required'),
    resourceURL: Yup.string().required('Required'),
    imageUrl: Yup.string().required('Required'),
    section: Yup.number().required('Required').typeError('Required'),
});

export const partnerResourceSectionValidationSchema = Yup.object().shape({
    sectionName: Yup.string().required('Required'),
});

/**
 * Creates a Yup test for validating that the lowest rate does not exceed the highest rate
 * @param lowestRateFieldName - The field name for the lowest rate
 * @param highestRateFieldName - The field name for the highest rate
 * @returns Yup test function
 */
export const createLowestRateValidation = (
    lowestRateFieldName: string,
    highestRateFieldName: string
) => {
    return function (this: Yup.TestContext) {
        const { parent } = this;
        const lowestRate = parent[lowestRateFieldName];
        const highestRate = parent[highestRateFieldName];

        // Only validate if both values are present, are numbers, and both have meaningful values
        if (
            typeof lowestRate === 'number' &&
            typeof highestRate === 'number' &&
            lowestRate > 0 &&
            highestRate > 0
        ) {
            if (lowestRate > highestRate) {
                return this.createError({
                    path: this.path,
                    message: 'Lowest rate cannot exceed highest rate',
                });
            }
        }

        return true;
    };
};

/**
 * Creates a Yup test for validating that the highest rate is not less than the lowest rate
 * @param lowestRateFieldName - The field name for the lowest rate
 * @param highestRateFieldName - The field name for the highest rate
 * @returns Yup test function
 */
export const createHighestRateValidation = (
    lowestRateFieldName: string,
    highestRateFieldName: string
) => {
    return function (this: Yup.TestContext) {
        const { parent } = this;
        const lowestRate = parent[lowestRateFieldName];
        const highestRate = parent[highestRateFieldName];

        // Only validate if both values are present, are numbers, and both have meaningful values
        if (
            typeof lowestRate === 'number' &&
            typeof highestRate === 'number' &&
            lowestRate > 0 &&
            highestRate > 0
        ) {
            if (highestRate < lowestRate) {
                return this.createError({
                    path: this.path,
                    message: 'Highest rate cannot be less than lowest rate',
                });
            }
        }

        return true;
    };
};
